
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#0069AA","width":"28","height":"20","rx":"2"}}),_c('path',{attrs:{"d":"M7.336 10.583a6.112 6.112 0 016.117-6.107 6.112 6.112 0 016.118 6.107 6.112 6.112 0 01-6.118 6.108 6.112 6.112 0 01-6.117-6.108","fill":"#0069AA"}}),_c('path',{attrs:{"d":"M17.153 10.463a3.674 3.674 0 00-2.362-3.426v6.852a3.674 3.674 0 002.362-3.426zm-4.994 3.425v-6.85a3.678 3.678 0 00-2.36 3.425 3.676 3.676 0 002.36 3.425zm1.317-9.216a5.796 5.796 0 00-5.8 5.791 5.795 5.795 0 005.8 5.79c3.204 0 5.8-2.592 5.8-5.79a5.797 5.797 0 00-5.8-5.791zM13.462 16.8c-3.506.016-6.391-2.819-6.391-6.27 0-3.773 2.885-6.382 6.39-6.381h1.644c3.464-.001 6.626 2.607 6.626 6.38 0 3.45-3.162 6.27-6.626 6.27h-1.643z","fill":"#FFF"}})])])
          )
        }
      }
    